import React, { useMemo } from 'react';
import { Stack, Typography } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';

const DateRangeControls = ({
  startDate,
  endDate,
  onStartDateChange,
  onEndDateChange,
  showRangeHint,
  maxSelectableDate,
}) => {
  const startMaxDate = useMemo(() => {
    if (endDate) {
      return endDate.subtract(1, 'day');
    }
    if (maxSelectableDate) {
      return maxSelectableDate.subtract(1, 'day');
    }
    return undefined;
  }, [endDate, maxSelectableDate]);

  const endMinDate = useMemo(() => {
    if (startDate) {
      return startDate.add(1, 'day');
    }
    return undefined;
  }, [startDate]);

  return (
    <Stack spacing={3}>
      <Typography variant="subtitle1" color="text.secondary">
        Select a date range to view manufacturing performance metrics.
      </Typography>
      <Stack
        direction={{ xs: 'column', sm: 'row' }}
        spacing={2}
        sx={{ width: '100%' }}
      >
        <DatePicker
          label="Start date"
          value={startDate}
          onChange={onStartDateChange}
          disableFuture
          maxDate={startMaxDate}
          slotProps={{
            textField: {
              fullWidth: true,
            },
          }}
        />
        <DatePicker
          label="End date"
          value={endDate}
          onChange={onEndDateChange}
          maxDate={maxSelectableDate}
          minDate={endMinDate}
          slotProps={{
            textField: {
              fullWidth: true,
            },
          }}
        />
      </Stack>

      {showRangeHint && (
        <Typography variant="body2" color="text.secondary">
          Select a start date and an end date at least one day later.
        </Typography>
      )}
    </Stack>
  );
};

export default DateRangeControls;
